
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import IconsMixin from '~/mixins/icons.mixin'

@Component
export default class IconMobile extends IconsMixin {
  @Prop({ required: false, default: 14 }) readonly width!: string
  @Prop({ required: false, default: 21 }) readonly height!: string
}
